import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-cadastro-consistente`

    return {
        index() {
            return repository.post(`${baseUrl}`);
        },
        getUnidades(params) {
            return repository.post(`${baseUrl}/unidade`, params)
        },
        getAreas(params) {
            return repository.post(`${baseUrl}/area`, params)
        },
        getMicroareas(params) {
            return repository.post(`${baseUrl}/microarea`, params)
        },
        list(params) {
            return repository.post(`${baseUrl}/list`, params)
        }, 
        getPacientes(params = {}) {
        
            return repository.post(`${baseUrl}/paciente`, params)
         },
    }
}
